import React, { Component } from 'react';
import { compose, bindActionCreators } from 'redux';
import { createAction } from 'redux-actions';
import { connect } from 'react-redux';

import './AutomaticDeferCancel.scss';

import { DEFER_RECURRING_TRANSACTION_FULFILLED } from '../../../redux/modules/automaticInvestments/automaticInvestments.module';
import {
  AUTOMATIC_TRANSACTION_DEFER_CANCEL,
  AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL,
} from '../../../redux/modules/modals/modals.module';
import { moduleActions } from '../../../redux/modules';
import { getHasCollegeOnly } from '../../../redux/modules/productTypes/productType.selectors';
import Button from '../../Shared/Button/Button';
import { AUTOMATIC_UPDATE_RELOAD } from '../../../settings/settings';
import { isCustomerWebViewEnabled } from '../../../redux/modules/authentication/authentication.module.selectors';
import { isProductType529 } from '../../../utils/funds/funds-utility';

class AutomaticDeferCancel extends Component {
  componentDidMount() {
    const { dispatchPageLoad, fund } = this.props;
    const modalName = isProductType529(fund.productType)
      ? 'College|Contribute|SkipCancelModal'
      : 'Buy|SkipCancelModal';
    dispatchPageLoad(modalName);
  }

  doDelete(fund, deferMonth) {
    const {
      actions: {
        updateSystematicTransaction,
        getSystematicPurchases,
        setAutoUpdateLoading,
        openModal,
      },
      dispatch,
      closeModal,
    } = this.props;
    closeModal(AUTOMATIC_TRANSACTION_DEFER_CANCEL, { fund: fund });

    Promise.all([
      dispatch(
        updateSystematicTransaction(
          fund,
          deferMonth,
          'MODIFY',
          'PURCHASE',
          null,
          'SKIP_CANCEL'
        )
      ),
      setAutoUpdateLoading(),
    ]).then(
      (res) => {
        res.map((response) => {
          const {
            action: { type },
          } = response;
          if (type === DEFER_RECURRING_TRANSACTION_FULFILLED) {
            const {
              value: {
                body: { transactions },
              },
            } = response;
            const allFailed = transactions.every(
              (transaction) => !transaction.success
            );
            if (allFailed) {
              openModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL, {
                fund: fund,
              });
            } else {
              Promise.all([getSystematicPurchases()]).then(
                () => {
                  dispatch(
                    createAction(`${AUTOMATIC_UPDATE_RELOAD}_FULFILLED`)(true)
                  );
                },
                () => {
                  const action = createAction(
                    `${AUTOMATIC_UPDATE_RELOAD}_REJECTED`
                  )(true);
                  dispatch(action);
                }
              );
            }
          }
          return response;
        });
      },
      () => {
        const action = createAction(`${AUTOMATIC_UPDATE_RELOAD}_FULFILLED`)(
          true
        );
        dispatch(action);
        openModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL, { fund: fund });
      }
    );
  }

  render() {
    const {
      closeModal,
      customerWebViewEnabled,
      fund,
      getHasCollegeOnly,
      deferedMonth,
    } = this.props;
    return (
      <div className="automatic-defer-cancel-container">
        <div className="automatic-defer-cancel-info-container">
          <div className="automatic-defer-cancel-title">
            Are you sure you want to cancel your skipped month?
          </div>
          <div className="automatic-defer-cancel-sub-title">
            Restoring your skipped months may take{' '}
            <span className="automatic-defer-cancel-emphasis">
              up to three business days
            </span>{' '}
            to process. If your next{' '}
            {getHasCollegeOnly ? 'contribution' : 'transaction'} date was
            originally scheduled for this time period, it may still be skipped.
          </div>
        </div>
        <div className="automatic-defer-cancel-buttons-container">
          <a
            className="automatic-defer-cancel-cancel-btn"
            id="cancel-delete-btn"
            onClick={() => closeModal(AUTOMATIC_TRANSACTION_DEFER_CANCEL)}
          >
            No, Don't Cancel
          </a>
          <Button
            className="automatic-defer-cancel-delete-btn"
            buttonType="primary"
            id="delete-btn"
            styleName="automatic-defer-cancel-delete-btn"
            disabled={customerWebViewEnabled}
            onClick={() => {
              this.doDelete(fund, deferedMonth);
            }}
          >
            Yes, Cancel
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    getHasCollegeOnly: getHasCollegeOnly(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...moduleActions }, dispatch),
  dispatch,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AutomaticDeferCancel
);
